<template>
  <div>
    <NotFound v-if="show404" return-path-name="find-symptoms" />
    <div v-else>
      <div class="container" v-if="isLoading">
        <div class="row">
          <div class="d-flex justify-content-center align-items-center">
            <Loading />
          </div>
        </div>
      </div>
      <div class="repair" v-else>
        <div class="container">
          <div class="row">
            <h5>Wycena</h5>
            <h1 class="intro-text">
              <strong>{{ workName }}</strong>
            </h1>
          </div>
        </div>
        <single-cost
          v-if="price"
          :work-min="price.workMin"
          :work-max="price.workMax"
          :part-min="price.partMin"
          :part-max="price.partMax"
          :estimated-max="price.estimatedMax"
          :estimated-min="price.estimatedMin"
          :contain-parts="price.containParts"
          :has-prices="price.hasPrices"
        />
        <div class="container mt-5" v-else>
          <span class="bold"
            >Ten samochód ma kilka wariantów - wybierz swój:</span
          >
          <ul>
            <li
              v-for="variant in variants"
              :key="variant.id"
              class="link-to-variant"
            >
              <router-link
                :to="{
                  name: 'tec-estimate-variant',
                  params: {
                    typeId: this.$route.params.typeId,
                    korId: this.$route.params.korId,
                    itemMpId: this.$route.params.itemMpId,
                    workId: variant.id,
                  },
                }"
              >
                {{ variant.name }}
              </router-link>
            </li>
          </ul>
        </div>
        <foot-notes />
        <div class="container">
          <div class="row">
            <div class="col-12">
              <mail-to-us
                bold-text="Masz inną wycenę?"
                small-text="Prześlij nam informację lub kosztorys do weryfikacji"
                :type="FormTypes.ESTIMATE"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import NotFound from "@/views/NotFound";
import Loading from "@/components/Loading";
import SingleCost from "@/components/repair-detail-components/SingleCost";
import MailToUs from "@/improvementForms/MailToUs";
import FootNotes from "@/components/repair-detail-components/FootNotes";
import { mapGetters } from "vuex";
import { FormTypes } from "@/improvementForms/formTypes";

export default {
  mounted() {
    this.fetchRepair();
  },
  data: function () {
    return {
      price: null,
      workName: "",
      variants: [],
      show404: false,
      isLoading: false,
      FormTypes,
    };
  },
  methods: {
    fetchRepair() {
      if (this.isLoading) return;
      this.isLoading = true;
      axios
        .get(
          `/api/tec/work/${this.$route.params.typeId}/${this.$route.params.korId}/${this.$route.params.itemMpId}/`
        )
        .then((response) => {
          this.workName = response.data.name;
          if (response.data.prices.length === 1) {
            this.price = response.data.prices[0];
            this.$router.push({
              name: "tec-estimate-variant",
              params: {
                typeId: this.$route.params.typeId,
                korId: this.$route.params.korId,
                itemMpId: this.$route.params.itemMpId,
                workId: this.price.id,
              },
            });
          } else {
            this.variants = response.data.prices;
            this.price = null;
          }
          this.isLoading = false;
          document.title = this.workName;
        })
        .catch((reason) => {
          if (reason.response.status === 404) {
            this.show404 = true;
            this.isLoading = false;
          } else {
            console.error(reason);
          }
        });
    },
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar"]),
  },
  watch: {
    "$route.params.korId": {
      handler: function () {
        this.fetchRepair();
      },
      deep: true,
      immediate: true,
    },
    getSelectedCar() {
      if (!this.getSelectedCar) {
        this.$router.push({ name: "index" });
      } else if (
        this.getSelectedCar &&
        this.$route.params.typeId !== this.getSelectedCar?.typeId.toString()
      ) {
        this.$router.push({
          name: "tec-estimate-list",
          params: { typeId: this.getSelectedCar.typeId },
        });
      }
    },
    "$route.params.itemMpId": {
      handler: function () {
        this.fetchRepair();
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    FootNotes,
    MailToUs,
    NotFound,
    Loading,
    SingleCost,
  },
};
</script>
<style scoped>
h5 {
  font-family: Comfortaa-light, serif;
  color: gray;
}

h1,
h6 {
  font-family: Roboto, sans-serif;
}

.link-to-variant {
  color: var(--brand-color);
  text-decoration: none;
  list-style-type: circle;
}

.bold {
  font-weight: bold;
}
</style>
